<template>
    <div>
        <div id="bim" style="width: 100vw;height: 100vh"></div>
    </div>
</template>

<script>
import myHttp from '../../untils/port';
import loadJs from '../../untils/loadJs';

export default {
    name: 'showBIM',

    data() {
        return {
            projectId: this.$route.query.projectId,
            fileId: this.$route.query.fileId,
            viewToken: '',
            app: undefined,
            viewer3D: undefined,
        }
    },

    mounted() {
        this.getViewToken();
    },

    created() {
        document.title = 'BIM展示';
    },

    methods: {
        getViewToken() {
            myHttp.getViewToken({ projectId: this.projectId, fileId: this.fileId }).then(res => {
                if (res.data.code === 200) this.showBIM(res.data.data);
                else this.$message.error(res.data.msg);
            });
        },
        showBIM(viewToken) {
            loadJs('https://static.bimface.com/api/BimfaceSDKLoader/BimfaceSDKLoader@latest-release.js')
                .then(() => {
                    let loaderConfig = new BimfaceSDKLoaderConfig();
                    loaderConfig.viewToken = viewToken;
                    BimfaceSDKLoader.load(loaderConfig, () => {
                        const element = document.getElementById('bim');
                        const webAppConfig = new Glodon.Bimface.Application.WebApplication3DConfig();
                        webAppConfig.domElement = element;
                        this.app = new Glodon.Bimface.Application.WebApplication3D(webAppConfig);
                        this.app.addView(viewToken);
                        this.viewer3D = this.app.getViewer();
                        this.viewer3D.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.ViewAdded, () => {
                            window.addEventListener('resize', () => this.viewer3D.resize(window.innerWidth, window.innerHeight));
                            const bf_button = document.getElementsByClassName('bf-button');
                            for (let i = 0; i < bf_button.length; i++) {
                                bf_button[i].style.width = '3.5vw';
                                bf_button[i].style.height = '3.5vw';
                                bf_button[i].style.fontSize = '2vw';
                                bf_button[i].style.padding = '0';
                            }
                            document.styleSheets[0].insertRule(
                                '.bf-button::before { height: 3.5vw; display: flex; justify-content: center; align-items: center }'
                            );
                            const bf_sub_toolbar = document.getElementsByClassName('bf-sub-toolbar')[0];
                            bf_sub_toolbar.style.right = '4vw';
                            this.viewer3D.render();
                        });
                    });
                });
        },
    },
}
</script>

<style lang="less" module>

</style>
